import { render, staticRenderFns } from "./proDocs.vue?vue&type=template&id=31189727&scoped=true"
import script from "./proDocs.vue?vue&type=script&lang=js"
export * from "./proDocs.vue?vue&type=script&lang=js"
import style0 from "./proDocs.vue?vue&type=style&index=0&id=31189727&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31189727",
  null
  
)

export default component.exports